import { render, staticRenderFns } from "./CompanyAuditRecordList.vue?vue&type=template&id=38d707d1&scoped=true&"
import script from "./CompanyAuditRecordList.vue?vue&type=script&lang=js&"
export * from "./CompanyAuditRecordList.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAuditRecordList.vue?vue&type=style&index=0&id=38d707d1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d707d1",
  null
  
)

export default component.exports